import { render, staticRenderFns } from "./TgMobileGameFilter.vue?vue&type=template&id=27afb202&"
import script from "./TgMobileGameFilter.vue?vue&type=script&lang=js&"
export * from "./TgMobileGameFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports